(() => {
  const money = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR',
  });

  const priceText = (cents) => money.format(cents / 100);

  const sizeStart = (size) => Number(String(size).split('-')[0]) || 0;

  const makePriceLabel = (label, iconUrl, prompt) => {
    const container = document.createElement('span');
    container.className = 'bb-size-lineups__price-label';
    const icon = document.createElement('img');
    icon.className = 'bb-size-lineups__price-icon';
    icon.src = iconUrl;
    icon.alt = '';
    icon.width = 24;
    icon.height = 24;
    if (prompt) {
      const text = document.createElement('span');
      const hint = document.createElement('small');
      hint.textContent = prompt;
      text.append(document.createTextNode(label), hint);
      container.append(icon, text);
    } else container.append(icon, document.createTextNode(label));
    return container;
  };

  const makePriceArrow = () => {
    const arrow = document.createElement('span');
    arrow.className = 'bb-size-lineups__price-arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';
    return arrow;
  };

  const shippingUrl = (family, size) => {
    const url = new URL('/pages/bestel', window.location.origin);
    url.searchParams.set('delivery', 'shipping');
    url.searchParams.set('family', family);
    url.searchParams.set('size', size);
    url.searchParams.set('kind', 'regular');
    return url.pathname + url.search;
  };

  const makeShippingOnlyCard = (group, family, size, variant) => {
    const card = document.createElement('div');
    card.className = 'bb-size-lineups__card bb-size-lineups__card--shipping-only';
    card.dataset.bbSliderSlide = '';
    card.dataset.bbLineupCard = '';
    card.dataset.bbSize = size.replace('-', '–') + ' cm';
    card.dataset.bbKind = 'regular';

    const media = document.createElement('div');
    media.className = 'bb-size-lineups__media';
    const image = document.createElement('img');
    image.src = group.dataset.bbShippingOnlyImage || group.dataset.bbFallbackImage;
    image.alt = family === 'with_clump' ? 'Illustratie van een boom met kluit' : 'Illustratie van een boom zonder kluit';
    image.loading = 'lazy';
    image.width = 474;
    image.height = 870;
    media.append(image);

    const details = document.createElement('div');
    details.className = 'bb-size-lineups__details';
    const badge = document.createElement('p');
    badge.className = 'bb-size-lineups__shipping-only-label';
    badge.textContent = 'Alleen thuisbezorgd';
    const caption = document.createElement('p');
    caption.className = 'bb-size-lineups__size-caption';
    caption.textContent = 'maat';
    const sizeText = document.createElement('p');
    sizeText.className = 'bb-size-lineups__size';
    sizeText.textContent = size.replace('-', '–') + ' cm';
    const prices = document.createElement('div');
    prices.className = 'bb-size-lineups__price-list';
    const pickup = document.createElement('p');
    pickup.className = 'bb-size-lineups__price-row bb-size-lineups__price-row--unavailable';
    const pickupLabel = makePriceLabel('Ophalen', group.dataset.bbPickupIcon);
    const pickupValue = document.createElement('strong');
    pickupValue.textContent = 'Niet beschikbaar';
    pickup.append(pickupLabel, pickupValue);
    const shipping = document.createElement('a');
    shipping.className = 'bb-size-lineups__price-row bb-size-lineups__price-row--link';
    shipping.href = shippingUrl(family, size);
    shipping.dataset.bbShippingChoice = '';
    const shippingLabel = makePriceLabel('Thuisbezorgen', group.dataset.bbDeliveryIcon, 'Stel bezorging samen');
    const shippingValue = document.createElement('strong');
    shippingValue.textContent = priceText(variant.price);
    const shippingEnd = document.createElement('span');
    shippingEnd.className = 'bb-size-lineups__price-end';
    shippingEnd.append(shippingValue, makePriceArrow());
    shipping.append(shippingLabel, shippingEnd);
    prices.append(pickup, shipping);
    details.append(badge, caption, sizeText, prices);
    card.append(media, details);
    return card;
  };

  const initialise = (scope = document) => {
    const catalog = window.BBTreeChoiceData;
    const chooser = document.querySelector('[data-bb-tree-choice]');
    if (!catalog || !chooser) return;
    let locations;
    try {
      locations = JSON.parse(chooser.querySelector('[data-bb-tree-data]').textContent).locations || [];
    } catch (_error) {
      return;
    }

    scope.querySelectorAll('[data-bb-lineup-group]:not([data-bb-lineup-ready])').forEach((group) => {
      group.dataset.bbLineupReady = '';
      const family = group.dataset.bbFamily;
      let shippingProduct;
      try {
        shippingProduct = JSON.parse(group.querySelector('[data-bb-lineup-shipping]').textContent);
      } catch (_error) {
        shippingProduct = null;
      }

      group.querySelectorAll('[data-bb-lineup-card]').forEach((card) => {
        const size = catalog.sizeKey(card.dataset.bbSize);
        const kind = card.dataset.bbKind;
        const shipping = catalog.uniqueVariants(shippingProduct)
          .find((item) => item.kind === kind && item.size === size)?.variant;
        const prices = locations.flatMap((location) => {
          const product = location[family];
          if (!product) return [];
          return catalog.uniqueVariants(product)
            .filter((item) => item.size === size && item.kind === kind)
            .map(({ variant }) => variant.price - (product.depositCents || 0));
        });
        const pickupPrice = card.querySelector('[data-bb-pickup-price]');
        const pickupLink = card.querySelector('[data-bb-pickup-choice]');
        const pickupUnavailable = card.querySelector('[data-bb-pickup-unavailable]');
        if (pickupPrice) pickupPrice.textContent = prices.length ? `Vanaf ${priceText(Math.min(...prices))}` : 'Niet beschikbaar';
        if (pickupLink) pickupLink.hidden = !prices.length;
        if (pickupUnavailable) pickupUnavailable.hidden = Boolean(prices.length);
        if (kind === 'premium' && !prices.length) card.hidden = true;

        const shippingPrice = card.querySelector('[data-bb-shipping-price]');
        const shippingLink = card.querySelector('[data-bb-shipping-choice]');
        const shippingUnavailable = card.querySelector('[data-bb-shipping-unavailable]');
        if (shippingPrice) shippingPrice.textContent = shipping ? priceText(shipping.price) : 'Niet beschikbaar';
        if (shippingLink) shippingLink.hidden = !shipping;
        if (shippingUnavailable) shippingUnavailable.hidden = Boolean(shipping);
      });

      const track = group.querySelector('[data-bb-slider-track]');
      if (track && shippingProduct?.variants?.length) {
        const existingSizes = new Set([...track.querySelectorAll('[data-bb-lineup-card][data-bb-kind="regular"]')]
          .map((card) => catalog.sizeKey(card.dataset.bbSize)));
        catalog.uniqueVariants(shippingProduct).filter((item) => item.kind === 'regular').forEach(({ size, variant }) => {
          if (!size || existingSizes.has(size)) return;
          existingSizes.add(size);
          const card = makeShippingOnlyCard(group, family, size, variant);
          const following = [...track.querySelectorAll('[data-bb-lineup-card][data-bb-kind="regular"]')]
            .find((item) => sizeStart(catalog.sizeKey(item.dataset.bbSize)) > sizeStart(size));
          track.insertBefore(card, following || track.querySelector('[data-bb-kind="premium"]'));
        });
        group.querySelector('[data-bb-slider]')?.dispatchEvent(new Event('bb:slider:refresh'));
      }

      group.addEventListener('click', (event) => {
        const link = event.target.closest('[data-bb-pickup-choice]');
        if (!link) return;
        const card = link.closest('[data-bb-lineup-card]');
        if (!card) return;
        event.preventDefault();
        chooser.dispatchEvent(new CustomEvent('bb:choose-tree', {
          detail: { family, size: card.dataset.bbSize, kind: card.dataset.bbKind },
        }));
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
  document.addEventListener('bb:tree-choice:ready', () => initialise());
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
